export default __webpack_public_path__ + "static/media/01_photo.50736a73.jpg";